export enum ValidationErrorType {
  GENERAL = 'GENERAL',
  // Required field not present.
  MISSING_FIELD = 'MISSING_FIELD',
  // Errors generated by validatePartySnapshot; required fields for embedded record fields
  // such as ior.address or seller.mid
  SNAPSHOT = 'SNAPSHOT',
}
